import React, { useContext, useEffect, useState } from "react";
import Select from "react-select";
import Skeleton from "react-loading-skeleton";
import { useNavigate } from "react-router-dom";
import QRCodeImg from "../../../assets/images/create-consortium/QRCode.svg";
import ConsortiumIcon from "../../../assets/images/create-consortium/consortium-icon.svg";
import ConsortiumQrModal from "./ConsortiumQrModal";
import { getNetworkByUserId } from "../../../api/admin";
import { Spinner } from "react-bootstrap";
import { AdminContext } from "../../../context/AdminContext";
import { toast } from "react-toastify";
import { toastWarning } from "../../Common/ToastAlert";
import customStyles from "../../../assets/sass/Common/selectStyles";

const AllConsortiumList = () => {
  const navigate = useNavigate();
  const [network, setNetwork] = useState([]);
  const [selectedOption, setSelectedOption] = useState(null);
  const [openModal, setOpenModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const { userId, userPermissions } = useContext(AdminContext);
  const [modalData, setModalData] = useState(null);
  // Ensure loading state resets after 1 second if needed
  useEffect(() => {
    setTimeout(() => {
      setLoading(false);
    }, 1000);
  }, []);

  // Map the network data including the active property
  const options =
    network?.map((networkItem) => ({
      value: networkItem.name,
      label: networkItem.name,
      id: networkItem.id,
      regionId: networkItem.regionId,
      active: networkItem.active, // add the active property here
    })) || [];

  const fetchAllNetworkData = async () => {
    try {
      setLoading(true);
      const getNetwork = await getNetworkByUserId({ userId });
      const res = getNetwork.data.result;
      setNetwork(res);

      // removed this code to get all the network in the dashboard
      // Set the selected option with the active property
      // setSelectedOption(
      //   res[0]
      //     ? {
      //         value: res[0].name,
      //         label: res[0].name,
      //         id: res[0].id,
      //         regionId: res[0].regionId,
      //         active: res[0].active,
      //       }
      //     : null,
      // );
      setLoading(false);
    } catch (error) {
      setLoading(false);
      toast.warning(error.response.data.message, toastWarning());
      toast.warning(
        "Hmm. Something doesn't seem right. Try refreshing or logging in again.",
        toastWarning(),
      );
    }
  };

  useEffect(() => {
    //get the network tab if userid exist
    if (userId) fetchAllNetworkData();
  }, [userId]);

  const navigateToNetwork = (networkId, networkName) => {
    localStorage.setItem("networkId", networkId);
    localStorage.setItem("networkName", networkName);
    navigate("/dashboard", {
      state: { networkId: networkId, networkName: networkName },
    });
  };

  const handleNavigation = (networkId, networkName) => {
    // Only navigate if the network is active
    if (selectedOption?.active) {
      navigateToNetwork(networkId, networkName);
    }
  };
  const canReadNetwork = userPermissions?.some((p) => p.name === "ReadNetwork");

  const handleOpenQr = (e, item) => {
    e.stopPropagation(); // Prevents navigateToNetwork from firing
    setModalData({
      ...item,
      label: item.name,
      value: item.name,
    });
    setOpenModal(true);
  };

  // sorting for network
  const displayNetworks = selectedOption
    ? network.filter((item) => item.id === selectedOption.id)
    : network;

  return (
    <React.Fragment>
      {openModal && (
        <ConsortiumQrModal
          show={openModal}
          onHide={() => setOpenModal(false)}
          data={modalData}
        />
      )}
      <div className="consortium-list-page">
        <div className="sub-header">
          <div className="title">Consortiums</div>
          <div className="action-items">
            <div className="d-flex gap-2">
              <button
                className="dsm-btn-secondary action-icon "
                onClick={() => navigate("/account/mobile-application")}
                title="Download Mobile App"
              >
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="22"
                  height="22"
                  fill="currentColor"
                  class="bi bi-phone"
                  viewBox="0 0 16 16"
                >
                  <path d="M11 1a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM5 0a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h6a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" />
                  <path d="M8 14a1 1 0 1 0 0-2 1 1 0 0 0 0 2" />
                </svg>
              </button>
              {/* <button
                className="dsm-btn-secondary action-icon consortium-qr-wiz"
                onClick={() => setOpenModal(true)}
                disabled={
                  userPermissions?.some(
                    (userPermission) => userPermission.name === "ReadNetwork",
                  )
                    ? false
                    : true
                }
              >
                <img src={QRCodeImg} alt="QR Code" />
              </button> */}

              <div className="select-item select-consortium-wiz">
                <Select
                  styles={customStyles}
                  closeMenuOnSelect={true}
                  onChange={(option) => setSelectedOption(option)}
                  options={options}
                  isClearable={true}
                  value={selectedOption}
                  // defaultValue={selectedOption}
                  placeholder={
                    selectedOption ? selectedOption.label : "Search Network"
                  }
                  isDisabled={
                    userPermissions?.some(
                      (userPermission) => userPermission.name === "ReadNetwork",
                    )
                      ? false
                      : true
                  }
                />
              </div>
            </div>
            <button
              className="dsm-btn-primary create-consortium-step"
              onClick={() => navigate("/home/create-consortium")}
              disabled={
                userPermissions?.some(
                  (userPermission) =>
                    userPermission.name === "CreationOfNetwork",
                )
                  ? false
                  : true
              }
            >
              Create New Consortium
            </button>
          </div>
        </div>
        <div className="body-content">
          {loading ? (
            <div className="loader">
              <Spinner animation="border" variant="primary" />
            </div>
          ) : (
            <>
              <div className="consortium-grid d-flex flex-wrap gap-5">
                {/* {selectedOption && ( */}
                {displayNetworks.map((item) => (
                  <div
                    className={`consortium-card consortium-card-wiz ${!item.active ? "disabled" : ""}`}
                    key={item.id}
                    onClick={() =>
                      item.active && navigateToNetwork(item.id, item.name)
                    }
                    style={{
                      cursor: item.active ? "pointer" : "not-allowed",
                      opacity: item.active ? 1 : 0.7,
                    }}
                  >
                    <div className="card-header d-flex justify-content-between">
                      <span
                        className={
                          item.active ? "success-badge" : "disabled-badge"
                        }
                      >
                        {item.active ? "Ready" : "Inactive"}
                      </span>
                    </div>

                    <div className="card-body">
                      <img src={ConsortiumIcon} alt="Consortium Icon" />
                      {/* CRITICAL FIX: Use item.name, not selectedOption.label */}
                      <p>{item.name}</p>
                    </div>

                    <div className="card-footer d-flex justify-content-between align-items-center">
                      <div>
                        Region:{" "}
                        <span>{item.regionId ? item.regionId : "-"}</span>
                      </div>

                      {/* QR Code in Footer */}
                      {item.active && (
                        <div
                          className={`qr-icon-wrapper ${!canReadNetwork ? "pe-none opacity-50" : ""}`}
                          onClick={(e) => handleOpenQr(e, item)}
                          title="View QR Code"
                          style={{ cursor: "pointer" }}
                        >
                          <img src={QRCodeImg} alt="QR Code" width="22" />
                        </div>
                      )}
                    </div>
                  </div>
                ))}
              </div>
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export default AllConsortiumList;
